import type { SxProps, Theme } from '@mui/material/styles';

/**
 * Product catalog CTA gradient (e.g. delete actions).
 * Prefer keeping usage aligned with catalog / CRM primary actions.
 */
export const CATALOG_CTA_GRADIENT = 'linear-gradient(to right, #2D63ED, #14B39B)';

export const CATALOG_CTA_GRADIENT_HOVER = 'linear-gradient(to right, #2557d8, #129e87)';

/** Action column: no gradient background; subtle hover. Gradient is on the icon (fill url #id). */
export const catalogActionIconButtonSx: SxProps<Theme> = {
  backgroundColor: 'transparent',
  color: 'inherit',
  '&:hover': {
    backgroundColor: 'rgba(45, 99, 237, 0.09)',
  },
};

/** Catalog gradient fill; requires `<CatalogActionIconGradientDefs id={sameId} />` in the tree. */
export function catalogActionSvgIconGradientSx(gradientDomId: string): SxProps<Theme> {
  const fill = `url(#${gradientDomId})`;
  return {
    '& path': { fill },
    '& circle': { fill },
    '& rect': { fill },
    '& polygon': { fill },
  };
}
